import { render, staticRenderFns } from "./SignosVitales.vue?vue&type=template&id=edf6bf24&scoped=true"
import script from "./SignosVitales.vue?vue&type=script&lang=js"
export * from "./SignosVitales.vue?vue&type=script&lang=js"
import style0 from "./SignosVitales.vue?vue&type=style&index=0&id=edf6bf24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf6bf24",
  null
  
)

export default component.exports